import React from 'react';
import { Select, SelectOption } from '../../../../../../../components/Select';
import { Signatory } from '../../../../../../../entities/v1/applicant_tracking/Signatory';

interface PropTypes {
  signatories: Signatory[];
  selectedSignatory?: Signatory;
  onChangeSignatory: (signatory: Signatory) => void;
}

function Dropdown(props: {
  label: string;
  options: SelectOption[];
  selected: SelectOption;
  disabled?: boolean;
  onChange?: (newOption: SelectOption) => void;
}) {
  return (
    <div className='d-flex align-items-center gap-2'>
      <label className='w-25 text-nowrap fw-semibold fs-5'>
        {props.label} <span className='ps-1 text-danger'>*</span>
      </label>
      <Select
        className='w-100'
        isClearable
        disabled={props.disabled}
        placeholder={`Select ${props.label}`}
        onChange={props.onChange}
        options={props.options}
        selected={props.selected}
      />
    </div>
  );
}

export function SignatoryDropdown(props: PropTypes) {
  if (props.signatories == null || props.signatories.length === 0) {
    return null;
  }

  const handleChangeSelectedSignatory = async (selected: SelectOption) => {
    if (selected == null) {
      return props.onChangeSignatory(null);
    }

    props.onChangeSignatory(
      props.signatories?.find((i) => i.id.toString() === selected.value),
    );
  };

  const loadSignatories = (signatories: Signatory[]): SelectOption[] => {
    return signatories?.map((v) => {
      return {
        label: v.user.name,
        value: v.id.toString(),
      };
    });
  };

  const selectedOption = () => {
    const selected = props.signatories?.find(
      (s) => s.id === props.selectedSignatory?.id,
    );

    if (selected == null) {
      return null;
    }

    return {
      value: selected.id.toString(),
      label: selected.user.name,
      selected: true,
    };
  };

  return (
    <Dropdown
      label={'Signatory'}
      options={loadSignatories(props.signatories)}
      onChange={handleChangeSelectedSignatory}
      selected={selectedOption()}
      disabled={props.signatories.length === 1}
    />
  );
}
